<div class="content-area">
  <div class="appointments-tab-outer">
    <div class="title-block">
      <h1>{{title}}</h1>
      <div class="title-block__right">
        <a class="back-btn" href="javascript:void(0);" (click)="onBack()"><i class="back-new"></i> Back</a>
      </div>
    </div>

    <div class="appointments-table-filer">
      <div class="appointments-table-filer__appit-legend">
        <ul>
          <li><span class="legend ready-for-scheduling"> Ready For Scheduling</span></li>
          <li><span class="legend upcoming"> Upcoming</span></li>
          <li><span class="legend no-show"> No Show</span></li>
          <!--<li><span class="legend complete"> Complete </span></li>-->
          <li><span class="legend cancel"> Cancel</span></li>
          <li><span class="legend voidreview">Potential Void</span></li>
          <li><span class="legend void">Void</span></li>
          <li><span class="legend complete">Complete</span></li>
        </ul>
      </div>

      <div class="appointments-table-filer__sort-by">

        <div class="from__group list-search-outer">
          <div class="from__group">
            <!-- <label class="form__label">Search</label> -->
            <div class="search-box">
              <input type="text" class="form__control" pInputText placeholder=" S/O ID, Patient & DOB" #searchBox
                style="width:auto" (keyup.enter)="onSearchButtonClick()">

              <button class="search-btn " pButton type="button" (click)="onSearchButtonClick()">
                <i class="search-new"></i>
              </button>
            </div>
          </div>
        </div>

        <a href="javascript:void(0);" class="filter-show-hide" (click)="Op1.toggle($event)">
          <svg width="21" height="5" viewBox="0 0 21 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2.5" cy="2.5" r="2.5" fill="#707070"></circle>
            <circle cx="10.5" cy="2.5" r="2.5" fill="#707070"></circle>
            <circle cx="18.5" cy="2.5" r="2.5" fill="#707070"></circle>
          </svg>
        </a>
        <p-overlayPanel #Op1 appendTo="body" class="search-filter">
          <div class="quick-link-menu">
            <ul>
              <li *ngIf="isSendInvitationPermission">
                <a class="invite-schedule" routerLinkActive="active" href="javascript:void(0)"
                  (click)="SendInvitationforAppointment();">Send Invite</a>
              </li>
              <!--<li>
                <a class="invite-schedule" href="javascript:void(0)" (click)="LockAppoinments()">Assign Calls</a>
              </li>-->
              <!--<li *ngIf="isLockedAppointments">
                <a class="invite-schedule" href="javascript:void(0)"
                   (click)="ViewLockedAppoinments()">View Assigned Calls</a>
              </li>-->
              <!-- <li><a class="invite-schedule" href="javascript:void(0)" (click)="updateVoidSalesOrder()">Void S/O
                  Status</a></li> -->
              <!--<li>
                <a class="invite-schedule" href="javascript:void(0)" (click)="ExportCancelAppointment()">Export</a>
              </li>-->
              <li>
                <a class="invite-schedule" href="javascript:void(0)" routerLinkActive="active"
                  (click)="totalRecords > 0 ? CancelVoidAllAppointmentS('voidreview',true): ''">Void Review</a>
              </li>
              <li>
                <a class="invite-schedule" href="javascript:void(0)" routerLinkActive="active"
                  (click)="totalRecords > 0 ? CancelVoidAllAppointmentS('void',true): ''">Void</a>
              </li>
              <li>
                <a class="invite-schedule" href="javascript:void(0)" routerLinkActive="active"
                  (click)="totalRecords > 0 ? SendVoiceMailSelectedSales(true): ''">Voice Mail</a>
              </li>

            </ul>
          </div>
        </p-overlayPanel>

        <a href="javascript:void(0);" class="filter-block" (click)="NotScheduledAddColumn.toggle($event)"
          pTooltip="Column Display Settings" tooltipPosition="left">
          <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0525 2.89474H15.2104" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M11.4211 1V4.78946" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M11.421 2.89474H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M4.78946 9.5263H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M8.57886 7.63157V11.421" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M18.9999 9.5263H8.57886" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M18.0525 16.1579H15.2104" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M11.4211 14.2631V18.0526" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M11.421 16.1579H1" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </a>

        <a href="javascript:void(0);" class="filter-block filter-block filter-show-hide"
          (click)="tableFilterCancelled.toggle($event)">
          <img src="assets/img/filter-ic.svg" width="18" alt="filters">
        </a>

        <p-overlayPanel #tableFilterCancelled class="search-filter" [dismissable]="true" [showCloseIcon]="true">

          <div class="search-box-outer overflow-visible">
            <h2 class="filter-title">Filters</h2>

            <div class="form__group full-width quick-date-filter-box" style="margin: 0 0 2rem 0 !important;">
              <label class="form__label">Date Filters</label>
              <div class="search-box">
                <input matInput class="form__control" ngxDaterangepickerMd placeholder="Quick Filters"
                  [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [customRangeDirection]="true"
                  [(ngModel)]="NSSelectedDateRange" [ranges]="ranges" [showClearButton]="true" [showCancel]="true"
                  [linkedCalendars]="true" [isTooltipDate]="isTooltipDate" [isInvalidDate]="isInvalidDate"
                  [locale]="callocales" [keepCalendarOpeningWithRange]="true" [showRangeLabelOnInput]="true" />

                <button class="search-btn">
                  <i class="search-new"></i>
                </button>
              </div>
            </div>

            <div class="from__group">
              <label class="form__label">Branch</label>
              <p-select class="form__dropdown select-box" [options]="branchResponseModel"
                [(ngModel)]="selectedNSbranch" id="branchDropdown" placeholder="Select" optionLabel="crmBranchName"
                filter="true" (onChange)="onBranchChange($event)"></p-select>
            </div>

            <div class="from__group">
              <label class="form__label">Doctor</label>
              <p-select class="form__dropdown select-box" [options]="doctorResponseModel" name="Doctors" placeholder="Select Doctor"
                [(ngModel)]="selectedDoctorResponseModel" (onChange)="onDoctorChange($event)"
                optionLabel="doctorFullName" filter="true">
              </p-select>
            </div>

            <div class="from__group">
              <label class="form__label">Facility</label>
              <p-select class="form__dropdown select-box" [options]="facilityResponseModelDropdownList"
                name="Doctors" placeholder="Select Doctor Facility" [(ngModel)]="selectedfacilityResponseModel"
                (onChange)="onFacilityChange($event)" optionLabel="crmFacilityName"  filter="true">
              </p-select>
            </div>
            <div class="from__group">
              <label class="form__label">Time Zone</label>
              <p-multiSelect class="form__multiSelect select-box" [ngModelOptions]="{standalone: true}"
                [(ngModel)]="selectedTimeZone" [options]="timeZoneList" placeholder="Select"
                (onChange)="onTimeZoneChange($event.value)" optionLabel="appStandardTimeZoneName" [virtualScroll]="true"
                selectedItemsLabel="{0} Time Zone Selected"></p-multiSelect>
            </div>

            <div class="from__group">
              <label class="form__label">Primary Insurance</label>
              <p-multiSelect class="form__multiSelect select-box" [ngModelOptions]="{standalone: true}"
                [(ngModel)]="selectedPrimaryInsuranceProvider" [options]="primaryInsuranceProviderList"
                placeholder="Select" (onChange)="onPrimaryInsurationProviderChange($event.value)"
                optionLabel="crmPolicyHolderName" [showToggleAll]="false" [selectionLimit]="5"
                selectedItemsLabel="{0} Primary Insurance Provider Selected"></p-multiSelect>
              <small>[You can select max 5 items at a time]</small>
            </div>

            <div class="btn-block">
              <button class="btn btn--primary"
                (click)="onSOFilterSearch();closeSearchFilter($event, tableFilterCancelled);">Search</button>
              <a class="btn btn--secondary clear-filter" href="javascript:void(0)"
                (click)="onClearSOFilterSearch();onSOFilterSearch();closeSearchFilter($event, tableFilterCancelled);">
                Clear
              </a>
            </div>

          </div>
        </p-overlayPanel>

      </div>
    </div>


    <div class="page-scroll appointments-list app-not-scheduled-list"
      [ngClass]="filterShowHide ? 'filter-active' : 'filter-inactive'">
      <div class="appointments-scroll-inner-side">
        <!-- <div class="appointment-actionmenu add-table-column" *ngIf="totalRecords > 0">
          <a href="javascript:void(0)" (click)="NotScheduledAddColumn.toggle($event)">
            <svg height="512pt" fill="#656565" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m256 512c-141.164062 0-256-114.835938-256-256s114.835938-256 256-256 256 114.835938 256 256-114.835938 256-256 256zm0-480c-123.519531 0-224 100.480469-224 224s100.480469 224 224 224 224-100.480469 224-224-100.480469-224-224-224zm0 0" />
              <path
                d="m368 272h-224c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h224c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" />
              <path
                d="m256 384c-8.832031 0-16-7.167969-16-16v-224c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v224c0 8.832031-7.167969 16-16 16zm0 0" />
            </svg>
          </a>
        </div> -->

        <p-table #table [ngClass]="isOnlyFixedColumnVisible ? 'onlyvisiblecolumn' : ''"
          class="table-outer appt-not-scheduled" sortMode="single" [sortOrder]="1" sortField="crmPatientName"
          [paginator]="totalRecords>0?true:false" [rows]="getTotalRows()" [totalRecords]="totalRecords" [lazy]="true"
          [customSort]="true" [first]="searchRequestModel?.FirstRecordIndex" [value]="salesOrders"
          (onLazyLoad)="onLazyLoad($event)" [(selection)]="selectedsalesOrders" selectionMode=""
          (selectionChange)="onSelectionChange($event)" [columns]="userPreferenceColumn" [frozenColumns]="frozencols"
          [scrollable]="true" scrollHeight="calc(100vh - 297px)" dataKey="crmSalesOrderId" scrollDirection="both">

          <ng-template pTemplate="header" let-columns>
            <!-- *ngIf="totalRecords > 0" -->
            <tr *ngIf="totalRecords > 0">
              <th class="table-outer__th appt-action-column" pFrozenColumn></th>
              <th class="table-outer__th appt-so-id" pFrozenColumn>
                <span class="table-header-flex">
                  <p-tableHeaderCheckbox #headerCheckBox></p-tableHeaderCheckbox>
                  <span class="header-soid__name">S/O ID</span>
                </span>
              </th>
              <th class="table-outer__th appt-patient-name" pFrozenColumn pSortableColumn="crmPatientName">
                Patient details
                <p-sortIcon field="crmPatientName"></p-sortIcon>
              </th>
              <th class="table-outer__th appt-classification" pFrozenColumn pSortableColumn="crmClassification">
                Classification Type
                <p-sortIcon field="crmClassification"></p-sortIcon>
              </th>
              <!--<th class="table-outer__th" pFrozenColumn pSortableColumn="CrmIsCallBack">
    Current Status
    <p-sortIcon field="CrmIsCallBack"></p-sortIcon>
  </th>-->
              <th class="table-outer__th appt-status" pFrozenColumn pSortableColumn="crmSalesorderStatus">
                Status
                <p-sortIcon field="crmSalesorderStatus"></p-sortIcon>
              </th>
              <ng-container *ngFor="let co of columns">
                <th *ngIf="co.field != 'crmPatientName && crmClassification && crmIsCallBack' && co.visible===true"
                  class="table-outer__th" pSortableColumn="{{co.sortFieldName}}">
                  {{co.header}}
                  <p-sortIcon field="{{co.sortFieldName}}"></p-sortIcon>
                </th>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-salesorder let-columns="columns">
            <tr
              [ngClass]="salesorder.schAppointmentId > 0 &&  salesorder.schAppointmentBookedBy==0?'appBookMyPatient':''">
              <td class="table-outer__td appt-action-column" pFrozenColumn>
                <a class="actionmenu-btn" href="javascript:void(0)"
                  (click)="selectNonScheduleSalesOrder($event,salesorder,NotScheduledAction)">
                  <!-- <i class="ic action-ic"></i> -->
                  <svg id="Layer_1" class="appt-action-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 29.96 122.88">
                    <path class="cls-1"
                      d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Zm0,92.93a15,15,0,1,1-15,15,15,15,0,0,1,15-15Zm0-46.47a15,15,0,1,1-15,15,15,15,0,0,1,15-15Z" />
                  </svg>
                </a>

                <p-overlayPanel class="table-action-popup NotScheduledAction appointment-Action" #NotScheduledAction>
                  <ul class="quick-link-menu">

                    <li *ngIf="isAppointmentScheduledPermission  && selectedSalesOrder.schAppointmentId==0">
                      <a href="javascript:void(0)"
                        (click)="showDialog(selectedSalesOrder.crmSalesOrderId,selectedSalesOrder.appointmentId)">
                        <svg version="1.1" id="Capa_1" fill="#6F64A7" xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.867 477.867"
                          style="enable-background:new 0 0 477.867 477.867;" xml:space="preserve">
                          <g>
                            <g>
                              <path d="M426.667,51.2h-51.2V17.067C375.467,7.641,367.826,0,358.4,0s-17.067,7.641-17.067,17.067V51.2h-204.8V17.067
                                    C136.533,7.641,128.892,0,119.467,0S102.4,7.641,102.4,17.067V51.2H51.2C22.923,51.2,0,74.123,0,102.4v324.267
                                    c0,28.277,22.923,51.2,51.2,51.2h375.467c28.277,0,51.2-22.923,51.2-51.2V102.4C477.867,74.123,454.944,51.2,426.667,51.2z
                                    M443.733,426.667c0,9.426-7.641,17.067-17.067,17.067H51.2c-9.426,0-17.067-7.641-17.067-17.067V204.8h409.6V426.667z
                                    M443.733,170.667h-409.6V102.4c0-9.426,7.641-17.067,17.067-17.067h51.2v34.133c0,9.426,7.641,17.067,17.067,17.067
                                    s17.067-7.641,17.067-17.067V85.333h204.8v34.133c0,9.426,7.641,17.067,17.067,17.067s17.067-7.641,17.067-17.067V85.333h51.2
                                    c9.426,0,17.067,7.641,17.067,17.067V170.667z" />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M352.98,243.934c-6.614-6.388-17.099-6.388-23.712,0L204.8,368.401l-56.201-56.201c-6.78-6.548-17.584-6.36-24.132,0.419
                                    c-6.388,6.614-6.388,17.099,0,23.713l68.267,68.267c6.665,6.662,17.468,6.662,24.132,0l136.533-136.533
                                    C359.947,261.286,359.759,250.482,352.98,243.934z" />
                            </g>
                          </g>
                        </svg>
                        Schedule
                      </a>
                    </li>
                    <li *ngIf="isAppointmentRescheduledPermission && selectedSalesOrder.schAppointmentId>0">
                      <a href="javascript:void(0)"
                        (click)="showAppointmentDialog(selectedSalesOrder.crmSalesOrderId,selectedSalesOrder.schAppointmentId)">
                        <svg version="1.1" id="Capa_1" fill="#6F64A7" xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.867 477.867"
                          style="enable-background:new 0 0 477.867 477.867;" xml:space="preserve">
                          <g>
                            <g>
                              <path d="M426.667,51.2h-51.2V17.067C375.467,7.641,367.826,0,358.4,0s-17.067,7.641-17.067,17.067V51.2h-204.8V17.067
                                    C136.533,7.641,128.892,0,119.467,0S102.4,7.641,102.4,17.067V51.2H51.2C22.923,51.2,0,74.123,0,102.4v324.267
                                    c0,28.277,22.923,51.2,51.2,51.2h375.467c28.277,0,51.2-22.923,51.2-51.2V102.4C477.867,74.123,454.944,51.2,426.667,51.2z
                                    M443.733,426.667c0,9.426-7.641,17.067-17.067,17.067H51.2c-9.426,0-17.067-7.641-17.067-17.067V204.8h409.6V426.667z
                                    M443.733,170.667h-409.6V102.4c0-9.426,7.641-17.067,17.067-17.067h51.2v34.133c0,9.426,7.641,17.067,17.067,17.067
                                    s17.067-7.641,17.067-17.067V85.333h204.8v34.133c0,9.426,7.641,17.067,17.067,17.067s17.067-7.641,17.067-17.067V85.333h51.2
                                    c9.426,0,17.067,7.641,17.067,17.067V170.667z" />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M352.98,243.934c-6.614-6.388-17.099-6.388-23.712,0L204.8,368.401l-56.201-56.201c-6.78-6.548-17.584-6.36-24.132,0.419
                                    c-6.388,6.614-6.388,17.099,0,23.713l68.267,68.267c6.665,6.662,17.468,6.662,24.132,0l136.533-136.533
                                    C359.947,261.286,359.759,250.482,352.98,243.934z" />
                            </g>
                          </g>
                        </svg>
                        Reschedule
                      </a>
                    </li>
                    <li
                      *ngIf="!selectedSalesOrder.schIsLocked && isAppointmentVoidPermission && selectedSalesOrder.isScheduled">
                      <a href="javascript:void(0)" (click)="showVoidAppointment(selectedSalesOrder.schAppointmentId)">
                        <svg id="void-ic-new" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                          viewBox="0 0 48 48">
                          <path id="Path_1" data-name="Path 1"
                            d="M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0ZM4,24A20,20,0,0,1,36.755,8.6L8.6,36.755A19.914,19.914,0,0,1,4,24ZM24,44a19.911,19.911,0,0,1-12.552-4.439L39.56,11.45A19.989,19.989,0,0,1,24,44Z"
                            fill="#6f64a7" />
                        </svg>
                        Void
                      </a>
                    </li>
                    <li *ngIf="!selectedSalesOrder.schIsLocked">
                      <a href="javascript:void(0)" (click)="showVoidAppointmentA(selectedSalesOrder.schAppointmentId)">
                        <svg id="void-ic-new" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                          viewBox="0 0 48 48">
                          <path id="Path_1" data-name="Path 1"
                            d="M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0ZM4,24A20,20,0,0,1,36.755,8.6L8.6,36.755A19.914,19.914,0,0,1,4,24ZM24,44a19.911,19.911,0,0,1-12.552-4.439L39.56,11.45A19.989,19.989,0,0,1,24,44Z"
                            fill="#6f64a7" />
                        </svg>
                        Void Review
                      </a>
                    </li>
                    <li
                      *ngIf="!selectedSalesOrder.schIsLocked && isAppointmentVoidPermission && !selectedSalesOrder.isScheduled">
                      <a href="javascript:void(0)" (click)="showVoidSalesOrder(selectedSalesOrder.crmSalesOrderId)">
                        <svg id="void-ic-new" xmlns="http://www.w3.org/2000/svg" width="48" height="48"
                          viewBox="0 0 48 48">
                          <path id="Path_1" data-name="Path 1"
                            d="M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0ZM4,24A20,20,0,0,1,36.755,8.6L8.6,36.755A19.914,19.914,0,0,1,4,24ZM24,44a19.911,19.911,0,0,1-12.552-4.439L39.56,11.45A19.989,19.989,0,0,1,24,44Z"
                            fill="#6f64a7" />
                        </svg>
                        Void
                      </a>
                    </li>


                  </ul>
                </p-overlayPanel>
              </td>

              <td class="table-outer__td appt-so-id" pFrozenColumn>
                <span class="table-checkbox">

                  <span class="lock-icon" *ngIf="isRowDisabled(salesorder)"
                    pTooltip="Assigned to {{salesorder['schAppointmentLockedByPerson']}}"
                    (click)="Unlock(salesorder,salesorder['schAppointmentLockedBy'] === loggedInUserId)">
                    <svg id="_x31__x2C_5" fill="#868686" enable-background="new 0 0 24 24" height="512"
                      viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="m18.75 24h-13.5c-1.24 0-2.25-1.009-2.25-2.25v-10.5c0-1.241 1.01-2.25 2.25-2.25h13.5c1.24 0 2.25 1.009 2.25 2.25v10.5c0 1.241-1.01 2.25-2.25 2.25zm-13.5-13.5c-.413 0-.75.336-.75.75v10.5c0 .414.337.75.75.75h13.5c.413 0 .75-.336.75-.75v-10.5c0-.414-.337-.75-.75-.75z" />
                      <path
                        d="m17.25 10.5c-.414 0-.75-.336-.75-.75v-3.75c0-2.481-2.019-4.5-4.5-4.5s-4.5 2.019-4.5 4.5v3.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-3.75c0-3.309 2.691-6 6-6s6 2.691 6 6v3.75c0 .414-.336.75-.75.75z" />
                      <path
                        d="m12 17c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2.5c-.275 0-.5.224-.5.5s.225.5.5.5.5-.224.5-.5-.225-.5-.5-.5z" />
                      <path
                        d="m12 20c-.414 0-.75-.336-.75-.75v-2.75c0-.414.336-.75.75-.75s.75.336.75.75v2.75c0 .414-.336.75-.75.75z" />
                    </svg>
                  </span>

                  <p-tableCheckbox class="table-check-first" *ngIf="!isRowDisabled(salesorder)" [value]="salesorder"
                    [disabled]="isRowDisabled(salesorder)"></p-tableCheckbox>

                  <a (click)="onNavigateBrightTreeSalesOrderUrl(salesorder.crmSalesOrderAPPId)"
                    pTooltip="{{salesorder.crmSalesOrderAPPId}}"
                    href="javascript:void(0)">{{salesorder.crmSalesOrderAPPId}}</a>
                </span>
              </td>

              <td class="table-outer__td appt-patient-name" pFrozenColumn>
                <span class="patient">
                  <a href="javascript:void(0)"
                    (click)="onView(salesorder.crmSalesOrderId,salesorder.crmSalesorderStatus,salesorder.schAppointmentId)"
                    pTooltip="{{salesorder['crmPatientName']}}"
                    tooltipPosition="top">{{salesorder['crmPatientName']}}</a>

                  <span class="bright-tree-patient-url">
                    <a (click)="onNavigateBrightTreePatientUrl(salesorder['crmPatientBrightreeID'])"
                      href="javascript:void(0)">{{salesorder['crmPatientId']}}</a>
                    {{salesorder['crmPatientBirthdate'] | date:appDateFormat.dateFormat}}
                  </span>
                </span>
              </td>

              <td class="table-outer__td appt-classification" pFrozenColumn>
                <span pTooltip="{{salesorder.crmClassification}}"
                  class="text-ellipsis">{{salesorder.crmClassification}}</span>
              </td>


              <td class="table-outer__td appt-status" pFrozenColumn>
                <p [ngClass]="salesorder.crmSalesorderStatus=='Cancel'?'cancel':
                                  salesorder.crmSalesorderStatus=='No Show'?'no-show':
                                  salesorder.crmSalesorderStatus=='Booked'?'upcoming':
                                  salesorder.crmSalesorderStatus=='Complete'?'complete':
                                  salesorder.crmSalesorderStatus=='Void Review'?'voidreview':
                                  salesorder.crmSalesorderStatus=='Void'?'void' :
                                  'ready-for-scheduling'" class="status-block-box">

                  <!-- ::salesorder.schAppointmentStatus=='NoShow'?'no-show':'unreconciled' -->
                </p>
              </td>
              <ng-container *ngFor="let col of columns">
                <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'crmDoctorName'">
                  <span class="text-ellipsis"
                    pTooltip="{{salesorder.crmDoctorName}}">{{salesorder.crmDoctorName}}</span>
                </td>
                <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'crmBranch'">
                  <span class="text-ellipsis" pTooltip="{{salesorder.crmBranch}}">{{salesorder.crmBranch}}</span>
                </td>
                <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'dateTimeCreated'">
                  <span class="date-time">
                    {{salesorder['dateTimeCreated'] | date:appDateFormat.dateFormat}}
                  </span>
                </td>
                <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'dateTimeLastModified'">
                  <span class="date-time">
                    {{salesorder['dateTimeLastModified'] | date:appDateFormat.dateFormat}}
                  </span>
                </td>
                <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'schAppointmentDateTime'">
                  <span class="date-time" *ngIf="salesorder['schAppointmentDateTime']">
                    <span>{{salesorder['schAppointmentDateTime'] | date:appDateFormat.dateFormat}}</span>
                    <p>
                      {{salesorder['schAppointmentDateTime'] | date:'shortTime' | lowercase}}<span
                        class="timezone-code">{{salesorder['crmPatientTimeZone'] | timezone}} </span>
                    </p>
                  </span>
                </td>
                <td class="table-outer__td" *ngIf="col.visible===true && col.field == 'crmCallBackDateTime'">
                  <span class="date-time" *ngIf="salesorder['crmRequestCallBackDate']">
                    <span>{{salesorder['crmRequestCallBackDate'] | date:appDateFormat.dateFormat}}</span>
                    <p>
                      {{salesorder['crmRequestCallBackDate'] | date:'shortTime' | lowercase}}
                    </p>
                  </span>
                </td>

                <td class="table-outer__td"
                  *ngIf="col.visible===true && col.field != 'crmDoctorName' && col.field != 'crmBranch' && col.field != 'dateTimeCreated' && col.field != 'dateTimeLastModified' && col.field != 'schAppointmentDateTime'  && col.field != 'crmCallBackDateTime'">
                  <span class="text-ellipsis" tooltipPosition="left" pTooltip="{{salesorder[col.field]}}"
                    *ngIf="col.field !='amountDue' && col.field != 'crmClassificaitonduration' && col.field != 'lastCallDate'">{{salesorder[col.field]}}</span>
                  <span class="list-classification-type" *ngIf="col.field=='amountDue'">
                    ${{salesorder[col.field] }}
                  </span>
                  <span class="dateTimeCreated" *ngIf="col.field=='crmClassificaitonduration'">
                    {{salesorder[col.field]}} Minutes
                  </span>
                  <span class="date-time" *ngIf="col.field == 'lastCallDate'">
                    {{salesorder['lastCallDate'] | date:appDateFormat.dateFormat}}
                    <p>{{salesorder['lastCallDate'] | date:'shortTime' | lowercase}}</p>
                  </span>
                </td>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template pTemplate="paginatorleft" class="table-pagination">
            <span class="table-pagination__records">
              Total Records : &nbsp;<strong> {{totalRecords}}</strong>
            </span>
          </ng-template>
          <ng-template pTemplate="paginatorright" class="table-pagination">
            <span class="table-pagination__select">
              <p-select class="select-box" panelStyleClass="paginetion-selectbox" appendTo="body" [options]="pageSiges" [(ngModel)]="selectedpage"
                id="branchDropdown" placeholder="Select Page" [showClear]="true" optionLabel="name"
                (onChange)="onPageChange($event)"></p-select>
            </span>
          </ng-template>


        </p-table>

        <div class="no-records-found-appointment" *ngIf="!loading && !dataExpressionloading && totalRecords <= 0"
          [attr.colspan]="NsheduledTableDefaltColumns + selectedNonSColumns.length">
          No records found
        </div>
      </div>
    </div>

    <!--</ng-template>-->

  </div>

  <!--</p-tabView>-->
  <div class="loader-block" *ngIf="loading">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff" animationDuration=".8s">
    </p-progressSpinner>
  </div>
</div>
<!-- Not Scheduled -->

<p-overlayPanel styleClass="overlayPanel-add-column-popup" class="add-column-popup" #NotScheduledAddColumn>
  <div class="column-display-settings">
    <h3 class="column-display-settings__title">Column Display Settings</h3>
    <div class="column-display-settings__scroll">
      <ul class="quick-link-menu column-display-settings__list" cdkDropList (cdkDropListDropped)="drop($event)">
        <li class="column-display-settings__items" *ngFor="let col of userPreferenceColumn" cdkDrag>

          <span class="column-display-settings__icon" cdkDragHandle>
            <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.8 15.5C1.305 15.5 0.881101 15.3162 0.528301 14.9487C0.175501 14.5812 -0.000598472 14.14 1.52801e-06 13.625C1.52801e-06 13.1094 0.176401 12.6678 0.529201 12.3003C0.882001 11.9328 1.3056 11.7494 1.8 11.75C2.295 11.75 2.7189 11.9337 3.0717 12.3012C3.4245 12.6687 3.6006 13.11 3.6 13.625C3.6 14.1406 3.4236 14.5822 3.0708 14.9497C2.718 15.3172 2.2944 15.5006 1.8 15.5ZM7.2 15.5C6.705 15.5 6.2811 15.3162 5.9283 14.9487C5.5755 14.5812 5.3994 14.14 5.4 13.625C5.4 13.1094 5.5764 12.6678 5.9292 12.3003C6.282 11.9328 6.7056 11.7494 7.2 11.75C7.695 11.75 8.1189 11.9337 8.4717 12.3012C8.8245 12.6687 9.0006 13.11 9 13.625C9 14.1406 8.8236 14.5822 8.4708 14.9497C8.118 15.3172 7.6944 15.5006 7.2 15.5ZM1.8 9.875C1.305 9.875 0.881101 9.69125 0.528301 9.32375C0.175501 8.95625 -0.000598472 8.515 1.52801e-06 8C1.52801e-06 7.48438 0.176401 7.04281 0.529201 6.67531C0.882001 6.30781 1.3056 6.12438 1.8 6.125C2.295 6.125 2.7189 6.30875 3.0717 6.67625C3.4245 7.04375 3.6006 7.485 3.6 8C3.6 8.51562 3.4236 8.95719 3.0708 9.32469C2.718 9.69219 2.2944 9.87562 1.8 9.875ZM7.2 9.875C6.705 9.875 6.2811 9.69125 5.9283 9.32375C5.5755 8.95625 5.3994 8.515 5.4 8C5.4 7.48438 5.5764 7.04281 5.9292 6.67531C6.282 6.30781 6.7056 6.12438 7.2 6.125C7.695 6.125 8.1189 6.30875 8.4717 6.67625C8.8245 7.04375 9.0006 7.485 9 8C9 8.51562 8.8236 8.95719 8.4708 9.32469C8.118 9.69219 7.6944 9.87562 7.2 9.875ZM1.8 4.25C1.305 4.25 0.881101 4.06625 0.528301 3.69875C0.175501 3.33125 -0.000598472 2.89 1.52801e-06 2.375C1.52801e-06 1.85938 0.176401 1.41781 0.529201 1.05031C0.882001 0.682814 1.3056 0.499377 1.8 0.500002C2.295 0.500002 2.7189 0.683751 3.0717 1.05125C3.4245 1.41875 3.6006 1.86 3.6 2.375C3.6 2.89063 3.4236 3.33219 3.0708 3.69969C2.718 4.06719 2.2944 4.25063 1.8 4.25ZM7.2 4.25C6.705 4.25 6.2811 4.06625 5.9283 3.69875C5.5755 3.33125 5.3994 2.89 5.4 2.375C5.4 1.85938 5.5764 1.41781 5.9292 1.05031C6.282 0.682814 6.7056 0.499377 7.2 0.500002C7.695 0.500002 8.1189 0.683751 8.4717 1.05125C8.8245 1.41875 9.0006 1.86 9 2.375C9 2.89063 8.8236 3.33219 8.4708 3.69969C8.118 4.06719 7.6944 4.25063 7.2 4.25Z"
                fill="#B0A3EF" />
            </svg>
          </span>
          <div class="column-display-settings__text">
            <p-checkbox  name="columns" [binary]="true"
              [(ngModel)]="col.preferenceVisible" inputId="{{col.header}}"/>
              <label for="{{col.header}}">{{col.header}}</label>
          </div>

        </li>
      </ul>
    </div>
    <div class="column-display-settings__buttons">
      <button class="btn btn--primary"
        (click)="AddNonSColumnInTable($event,userPreferenceColumn);NotScheduledAddColumn.hide()">Save Changes</button>
      <button class="btn btn--secondary" (click)="CancelNonSColumn($event, NotScheduledAddColumn);">Cancel</button>
    </div>
  </div>
</p-overlayPanel>

<p-dialog [(visible)]="displayVoidAppointment" styleClass="display-close-icon" [modal]="true" [responsive]="true"
  appendTo="body">
  <div class="popup-content-outer cancel-appointment">
    <h2>Void Appointment</h2>
    <div class="schedulecall">
      <form class="form" [formGroup]="formCancelAppointment" autocomplete="off">
        <div class="schedulecall">

          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Reason</label>
              <p-select class="form__dropdown" [options]="voidReasonsResponseModel" formControlName="voidReason"  filter="true"
                placeholder="Select Reason" optionLabel="salesOrderVoidReason" [showClear]="true"></p-select>
              <div *ngIf="formCancelAppointmentSubmitted && fVoid.voidReason.errors" class="invalid-feedback-error">
                <span *ngIf="fVoid.voidReason.errors.required || fVoid.voidReason.errors.whitespace">
                  {{validationMessages.voidReason.required}}
                </span>

              </div>
            </div>
          </div>
          <div class="col">
            <div class="form__group full-width">
              <label class="form__label">Comment</label>
              <textarea class="form__textarea" pInputTextarea formControlName="voidReasonComments"
                maxlength="100"></textarea>
              <div *ngIf="formCancelAppointmentSubmitted && fVoid.voidReasonComments.errors"
                class="invalid-feedback-error">
                <span *ngIf="fVoid.voidReasonComments.errors.required || fVoid.voidReasonComments.errors.whitespace">
                  {{validationMessages.voidReasonComments.required}}
                </span>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="check receive-reminder wip-state-will-not-update form__checkbox-outer">
              <p-checkbox name="groupnamevoid" label="If box checked, the WIP State will not be updated in Brightree"
                [(ngModel)]="isBrightreeSystemAppUpdate" binary="true" (onChange)="onBTSelect($event)"
                [ngModelOptions]="{standalone: true}" inputId="IfboxcheckedtheWIPStatewillnotbeupdatedinBrightree4">
              </p-checkbox>
              <label class="form__label" for="IfboxcheckedtheWIPStatewillnotbeupdatedinBrightree4">If box checked, the WIP State will not be updated in Brightree</label>
            </div>
          </div>
          <div class="call-popup-appointment">
            <button class="btn btn--primary" (click)="voidAppointment()">Submit</button>
            <a href="javascript:void(0)" class="btn btn--secondary" (click)="cancelVoidAppointment()">Cancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="ConfirmInvitePatients" styleClass="display-close-icon" [modal]="true" appendTo="body">
  <div class="popup-content-outer confirm-invite-patients">
    <div *ngIf="restrictedSalesOrderIdToSendInvite?.length != totalSelectedSendInviteSalesOrderIds">
      <h2>Confirm Sending Invitation to Patients</h2>
      <div *ngIf="restrictedSalesOrderIdToSendInvite?.length==0">
        <div class="confirm-invite-patients__content-part">
          <p>
            You are about to send an invitation to {{totalSelectedSendInviteSalesOrderIds}} patient(s). Please click
            <strong>
              “Yes,
              confirm”
            </strong> to send an invitation to {{totalSelectedSendInviteSalesOrderIds}} patient(s).
          </p>
        </div>
      </div>

      <div *ngIf="restrictedSalesOrderIdToSendInvite?.length>0">
        <div class="confirm-invite-patients__content-part">
          <p>
            You have selected {{totalSelectedSendInviteSalesOrderIds}} patient(s), but
            {{restrictedSalesOrderIdToSendInvite?.length}} of them are not eligible to receive the invitation, because
            the self-scheduling service is disabled in their branch.
          </p>
          <p *ngIf="restrictedSalesOrderIdToSendInvite?.length>0">
            Please click <strong>
              “Yes,
              confirm”
            </strong> to send an invitation to {{totalSelectedSendInviteSalesOrderIds -
            restrictedSalesOrderIdToSendInvite?.length }} patient(s).
          </p>
          <p><strong>The following patient(s) are not eligible to receive an invitation:</strong></p>
        </div>
        <div class="popup-table-outer">
          <table class="custom-table">
            <thead>
              <tr>
                <th>S/O ID</th>
                <th>Patient Name</th>
                <th>Branch</th>
              </tr>
            </thead>
            <tbody *ngFor="let restrictedSalesOrder of restrictedSalesOrderIdToSendInvite">
              <tr>
                <td>{{restrictedSalesOrder.crmSalesOrderAPPId}}</td>
                <td>{{restrictedSalesOrder.crmPatientName | titlecase}}</td>
                <td>{{restrictedSalesOrder.crmBranch}}</td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>

      <div class="confirm-invite-patients__buttons-box">
        <a href="javascript:void(0)" class="btn btn--secondary" (click)="ConfirmInvitePatientsCancel()">No, Cancel</a>
        <button class="btn btn--primary" (click)="ConfirmSendInvitePatients()">Yes, Confirm</button>
      </div>
    </div>

    <div *ngIf="restrictedSalesOrderIdToSendInvite?.length == totalSelectedSendInviteSalesOrderIds">
      <h2>Can't Send Invitation to Patients</h2>
      <div class="confirm-invite-patients__content-part">
        <p>You can't send an invitation to the selected patients because the self-scheduling service is disabled for
          their branch.</p>
      </div>

      <div class="confirm-invite-patients__buttons-box">
        <button class="btn btn--primary" (click)="ConfirmInvitePatientsCancel()">Ok</button>
      </div>
    </div>
  </div>
</p-dialog>

<!--<p-toast position="bottom-right"></p-toast>-->
<!--<router-outlet></router-outlet>-->